import { memo } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../../../components/ui/accordion';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../components/ui/card';

const FAQ_ITEMS = [
  {
    id: 'item-1',
    question: 'O que é aderência?',
    answer:
      'A aderência é a porcentagem de entregadores que anteciparam em relação ao total de entregadores que realizaram corrida',
  },
  {
    id: 'item-2',
    question: 'O que é Total antecipado do dia?',
    answer: 'É o valor antecipado aos entregadores, ou seja, o valor de compra.',
  },
  {
    id: 'item-3',
    question: 'Total de entregadores é referente a quê?',
    answer:
      'Ao total de entregadores únicos registrado no arquivos de pedidos.',
  },
  {
    id: 'item-4',
    question: 'O ticket médio é referente a qual valor?',
    answer:
      'O ticket médio é referente ao valor de Face. É desta forma para verificar se o valor do deságio está apropriado ao valor de face do crédito.',
  },
] as const;

export const StatisticsFaq = memo(function StatisticsFaq() {
  return (
    <Card className="bg-white border-[hsl(214,32%,91%)] shadow-sm">
      <CardHeader>
        <CardTitle className="text-[hsl(210,50%,10%)]">
          Perguntas Frequentes
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className="border-[hsl(214,32%,91%)]"
            >
              <AccordionTrigger className="text-[hsl(210,50%,10%)] hover:text-[hsl(210,35%,32%)]">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-[hsl(215,16%,47%)]">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </CardContent>
    </Card>
  );
});
